import {useParams} from "react-router";
import {useEffect, useState} from "react";
import useModal from "../../hooks/useModal";
import PageContainer from "../../componets/containers/PageContainer";
import Str from "../../helpers/Str";
import {IoArrowBack} from "react-icons/io5";
import {Link} from "react-router-dom";
import Carousel from "react-multi-carousel";
import Modal from "../../componets/modal/Modal";
import equipmentApi from "../../services/equipmentApi";


export default function ViewEquipment() {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [bigImage, setBigImage]: any = useState();

    const [equipment, setEquipment]: any = useState();
    const { modalProps, open, close } = useModal();
    const getDatas = async () => {
        const {data, isError} = await equipmentApi.getEquipmentsView(params.id)
        if (!isError){

            setEquipment(data);
            setBigImage(data.images[0])
        }
        setLoading(false);
    }
    useEffect(() => {getDatas()}, [])

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };
    return(
        <PageContainer>
            <>
                {
                    loading ?
                        <div className={'w-full h-[calc(90vh_-_80px)]'}>
                            <span className="flex items-center justify-center w-full h-full h-7">
                                <svg className="animate-spin -ml-1 mr-3 h-[45px] w-[45px] text-[#003641]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#003641"  strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </span>
                        </div>
                        :
                        <div className={'mb-32'}>
                            <div>
                                <Link to={'/equipamentos'}
                                      className={'p-3 border mb-3 w-[100px] rounded-md flex items-center justify-center gap-1'}><IoArrowBack/> Voltar</Link>
                            </div>
                            <div className={'flex xs:flex-col md:flex-row w-full overflow-hidden relative gap-1'}>
                                {
                                    equipment?.images?.length ?
                                        <div className={'h-[700px] max-h-[60vh]'}>
                                            <img
                                                className={'w-full h-full min-h-full min-w-full max-h-full max-w-full object-cover'}
                                                src={equipment ? equipment?.images[0].image_path : ''}
                                            />
                                        </div>
                                        :
                                        ''
                                }

                                {
                                    !!equipment?.images?.length && equipment?.images?.length > 1 ?
                                        (
                                            <div className={'grid gap-2 grid-cols-[1fr_1fr] h-[700px] max-h-[60vh]'}>
                                            {
                                                equipment?.images.slice(1, 5).map((image: any, index: any) => {
                                                    return (
                                                            <img
                                                                className={'w-full h-full min-h-full min-w-full max-h-full max-w-full object-cover'}
                                                                src={image.image_path}
                                                            />
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                        :
                                        ''
                                }
                                <div
                                    className={'absolute flex items-center justify-center gap-[12px] bottom-1 right-1'}>
                                    <button onClick={() => open()}
                                            className={'p-2 border border-[#003641] text-[#003641] font-bold'}>Ver Todas
                                        as fotos
                                    </button>
                                </div>
                            </div>
                            <div className={'flex flex-col mb-5 w-full  mt-5 mb-5 gap-3'}>
                                <div className={'text-[20px] font-semibold gap-3 flex'}>
                                    <div>{equipment.nome}</div>
                                </div>
                                <div className={'text-[16px] mt-4 font-semibold flex flex-col gap-3'}>
                                    <div>{equipment.descricao} </div>
                                    <div>{equipment.tipo} </div>
                                </div>
                                <div className={' font-bold text-[25px]'}>
                                    <div className={'flex flex-col'}>
                                        <div>
                                            Valor do equipamento
                                        </div>
                                        <div>
                                            {Str.currencyMask(equipment.valor)}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                }

                <Modal
                    title={"Imagens"}
                    {...modalProps}
                >
                    {
                        loading ?
                            <span className="flex items-center justify-center h-7">
                            <svg className="animate-spin -ml-1 mr-3 h-[14px] w-[14px] text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                            :
                            <>
                                <div className={'flex justify-center'}>
                                    {
                                        bigImage ?
                                            <img className={'h-[450px]'} src={bigImage ? bigImage.image_path : ''}/> : ''
                                    }

                                </div>

                                <div className={'w-full mt-3'}>
                                    <Carousel centerMode={true} responsive={responsive}>
                                        {
                                            equipment.images.map((image: any) => {
                                                return(
                                                    <img
                                                        onClick={() => setBigImage(image)}
                                                        className={'h-[200px] cursor-pointer'}
                                                        src={image.image_path}
                                                    />
                                                )
                                            })

                                        }
                                    </Carousel>
                                </div>
                            </>
                    }

                </Modal>
            </>
        </PageContainer>
    )
}